/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
$(document).on("turbo:load", function () {
  const itemSelector = "[data-lesson],[data-post]"

  $("[data-search-block][data-total]").each(function () {
    if ($(this).data("total") <= 24) {
      return $(this).find("[data-load-more]").hide()
    }
  })

  $("[data-more-button]").click(function (e) {
    e.preventDefault()
    const $loadBtn = $(this)
    if ($loadBtn.is(":disabled")) {
      return
    }

    const $section = $loadBtn.closest("[data-search-block]")
    const nextPage = parseInt($section.data("page")) + 1
    const filter = $loadBtn.data("filter")

    const searchUrl =
      "search?utf8=✓" +
      "&page=" +
      nextPage +
      "&qs=" +
      $("#search-param").text() +
      "&filter=" +
      filter

    $.ajax({
      type: "get",
      dataType: "script",
      url: searchUrl,
    })

    if ($section.data("total") <= nextPage * 24) {
      return $section.find("[data-load-more]").hide()
    }
  })

  const selectFilter = function (filterId) {
    const $filter = $(`[data-search-filter=${filterId}]`)
    $("[data-search-filter]").removeClass("current")
    $filter.addClass("current")

    if (filterId === "all") {
      $("[data-search-block]").show().attr("data-enabled", "true")
      return history.pushState(null, null, window.location.href.split("#")[0])
    } else {
      $("[data-search-block]").hide().attr("data-enabled", "false")
      $(`[data-search-block=${filterId}]`).show().attr("data-enabled", "true")
      $("#" + filterId)
        .get(0)
        .scrollIntoView()
      return history.pushState(null, null, "#" + filterId)
    }
  }

  $("body").on("click.searchResults.filter", "[data-search-filter]", e =>
    selectFilter($(e.currentTarget).data("search-filter"))
  )

  return $(document).ready(function () {
    const filterHashes = {
      "#tededlessons": "ted-ed-lessons",
      "#bestofweb": "teded-best-web",
      "#blogposts": "#blog-posts",
    }
    const filterId = filterHashes[window.location.hash]
    if (filterId) {
      return selectFilter(filterId)
    }
  })
})
